(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MM-Product-Description"] && !Shopify.designMode) return;
  try {
    
  function mmCheckShowMore(btn, container, text) {
    var clone = text.cloneNode(true);
    clone.style.cssText = [
      'position:absolute',
      'left:-9999px',
      'top:-9999px',
      'width:' + text.offsetWidth + 'px',
      'display:block',
      '-webkit-line-clamp:unset',
      'overflow:visible',
      'max-height:none',
      'visibility:hidden'
    ].join(';');
    document.body.appendChild(clone);
    var fullHeight = clone.scrollHeight;
    document.body.removeChild(clone);

    var clampedHeight = text.clientHeight;
    btn.style.display = fullHeight > clampedHeight + 1 ? '' : 'none';
  }

  function mmInitShowMoreToggles() {
    document.querySelectorAll('[data-show-more-toggle]').forEach(function (btn) {
      if (btn.dataset.showMoreInit) return;
      btn.dataset.showMoreInit = 'true';

      var container = btn.closest('.mm-product-description-description-long');
      if (!container) return;

      var text = container.querySelector('.mm-product-description-description-text');
      if (!text) return;

      btn.addEventListener('click', function () {
        container.classList.toggle('expanded');
      });

      // Measure on load, then re-measure if layout changes (e.g. async bundle loads)
      mmCheckShowMore(btn, container, text);

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () {
          mmCheckShowMore(btn, container, text);
        });
        ro.observe(text);
      }
    });
  }

  function mmRunAfterFonts(fn) {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fn);
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  mmRunAfterFonts(mmInitShowMoreToggles);

  } catch(e) { console.error(e); }
})();
})();
